const links = {
  ru: "http://ifc.steccom.ru",
  en: "http://ifc.steccom.ru/index-en.html",
  zh: "http://ifc.steccom.ru/index-en.html"
};

export default {
  computed: {
    connectLink() {
      return links[this.$i18n.locale];
    }
  }
};
